import React from 'react';

/**
 * Render a dialog-override slot that may be either a static `ReactNode` or a
 * function component receiving the dialog's runtime props. Returning `null`
 * lets callers fall back to the shared default with `renderSlot(...) ?? default`.
 *
 * A function slot is mounted via JSX so it lives inside the dialog's own
 * render context — hooks, Suspense (for `React.lazy` slots), and surrounding
 * providers all work as usual.
 *
 * @template P
 * @param {React.ReactNode | React.ComponentType<P>} slot
 * @param {P} [props]
 * @returns {React.ReactNode | null}
 */
const renderSlot = (slot, props) => {
  if (slot == null) {
    return null;
  }
  if (typeof slot === 'function') {
    const Slot = slot;
    return <Slot {...(props ?? {})} />;
  }
  return slot;
};

export default renderSlot;
